import React, { useState, useCallback, useEffect } from 'react'
import { Formik, Form } from 'formik'
import { useSelector } from 'react-redux'
import { useModal } from 'react-modal-hook'
import Loading from 'custom/assets/loaders/Loading'
import RequestService from '../../../../services/requests.service'
import { accountsSelector, carouselCurrentItemSelector } from '../../../../selectors'
import Modal from '../../../../components/Modal/Modal'
import InputError from '../../../../components/InputError/InputError'
import NeoButton from '../../../../components/NeoButton/NeoButton'
import NeoInput from '../../../../components/NeoInput/NeoInput'
import NeoOTP from '../../../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../../../components/FormComponents/NeoSuccess'
import { ChangeCardPINSchema } from '../../../../schemas/requests'
import { expiryMonth, expiryYear } from '../../../../utils/constants'
import { useHistory } from 'react-router-dom'
import NeoLoader from '../../../../components/FormComponents/NeoLoader'
import { ACCOUNT_SUB_MENUS, REQUEST_MENUS } from '../../../../layout/Layout/menu-names'
import LayoutWithAccountCard from '../../../../layout/Layout/layout-account-card'
import AccountDisplay from '../../../../components/account-display/account-display'

const parentMenus = REQUEST_MENUS.filter((ele) => ele.key !== 'DEBIT_CARD')
const menuDetails = REQUEST_MENUS.filter((ele) => ele.key === 'DEBIT_CARD')[0]
const parentMenuDetails = ACCOUNT_SUB_MENUS.filter((ele) => ele.key === 'REQUESTS')[0]

function ChangeCardPIN() {
  const [stage, setStage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [loadingCards, setLoadingCards] = useState(false)
  const [cards, setCards] = useState([{ cardNumber: '1234' }])
  const [formValues, setFormValues] = useState(null)
  const [error, setError] = useState('Error has occurred')
  const [otp, setOTP] = useState()
  const [message, setMessage] = useState('')
  const [oldPin, setOldPin] = useState('')
  const [newPinConfirm, setNewPinConfirm] = useState('')
  const [newPin, setNewPin] = useState('')
  const history = useHistory()
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{error?.code}</b> : {error?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={'OK'}
              onClick={() => {
                hideModal()
                history.push('/requests')
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  const getCards = useCallback(async () => {
    try {
      setLoadingCards(true)
      const response = await RequestService.getCardList({ accountNumber: currentAccountDetail?.accountNo })
      setCards(response.cardList)
      if (response.cardList.length === 0) {
        setError('No Cards Found')
        showModal()
      }
      setLoadingCards(false)
    } catch (err) {
      setLoadingCards(false)
    }
  }, [currentAccountDetail, showModal])

  useEffect(() => {
    getCards()
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP onSubmit={() => setStage(5)} otp={otp} setOTP={setOTP} />
      case 4:
        return <NeoSuccess message={message} linkPath='/requests' />
      default:
        return renderForm()
    }
  }

  const submitCardPINForm = useCallback(
    async (data, { setSubmitting }) => {
      if (newPin !== newPinConfirm) {
        setError('New Pin and Confirm Pin not matching')
        showModal()
        return
      }
      setLoading(true)
      setSubmitting(true)
      setFormValues(data)
      setSubmitting(false)
      setLoading(false)
      setStage(2)
    },
    [showModal],
  )

  const confirmClick = useCallback(async () => {
    setLoading(true)
    try {
      const response = await RequestService.changeCardPIN({
        cardNumber: formValues.cardNumber,
        expiryDate: `${formValues.expiryMonth}/${formValues.expiryYear}`,
        newPin,
        oldPin,
        uuid: 'icps_zicb_secure',
      })
      setMessage(response.message)
      setLoading(false)
      setStage(5)
    } catch (err) {
      setLoading(false)
    }
  }, [formValues, oldPin, newPin])

  const oldPinCallback = useCallback(
    async (e) => {
      const re = /^[0-9\b]+$/
      if (e.target.value === '' || re.test(e.target.value)) {
        setOldPin(e.target.value)
      }
    },
    [setOldPin],
  )

  const newPinCallback = useCallback(
    async (e) => {
      const re = /^[0-9\b]+$/
      if (e.target.value === '' || re.test(e.target.value)) {
        setNewPin(e.target.value)
      }
    },
    [setNewPin],
  )

  const newPinConfirmCallback = useCallback(
    async (e) => {
      const re = /^[0-9\b]+$/
      if (e.target.value === '' || re.test(e.target.value)) {
        setNewPinConfirm(e.target.value)
      }
    },
    [setNewPinConfirm],
  )

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>Change Card Pin Request</div>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <Formik
          initialValues={{
            cardNumber: '',
            expiryMonth: '',
            expiryYear: '',
            oldPin: '',
            newPin: '',
            confirmNewPin: '',
          }}
          enableReinitialize
          validationSchema={ChangeCardPINSchema}
          onSubmit={submitCardPINForm}>
          {({ isSubmitting, handleChange, errors, setFieldValue, touched }) => (
            <Form>
              {/* <div className='form-group my-2'>
                <NeoInput
                  mode='select'
                  text='Account Number'
                  name='accountNumber'
                  type='number'
                  onChange={(text) => {
                    handleChange(text)
                    setSelectedAccount(text.target.value)
                  }}
                  list={accounts}
                  keyValue='accountNo'
                />
                <div className='col-2'>{loadingCards ? <NeoLoader /> : null}</div>
                <InputError text={errors.accountNumber} touched={touched.accountNumber} />
              </div> */}
              <div className='form-group'>
                <NeoInput
                  mode='select'
                  type='number'
                  text='Card Number'
                  name='cardNumber'
                  disabled={loadingCards}
                  onChange={handleChange}
                  list={cards}
                  keyValue='cardNo'
                />
                <InputError text={errors.cardNumber} touched={touched.cardNumber} />
              </div>
              <div className='row d-flex'>
                <div className='form-group col-6'>
                  <NeoInput
                    mode='select'
                    text='Expiry Month'
                    name='expiryMonth'
                    disabled={loadingCards}
                    type='number'
                    placeholder='MM/YY'
                    onChange={handleChange}
                    list={expiryMonth}
                  />
                  <InputError text={errors.expiryMonth} touched={touched.expiryMonth} />
                </div>
                <div className='form-group  col-6'>
                  <NeoInput
                    mode='select'
                    text='Expiry Year'
                    name='expiryYear'
                    disabled={loadingCards}
                    type='number'
                    onChange={handleChange}
                    list={expiryYear}
                  />
                  <InputError text={errors.expiryYear} touched={touched.expiryYear} />
                </div>
              </div>
              <div className='form-group'>
                <NeoInput
                  type='password'
                  text='Old PIN'
                  disabled={loadingCards}
                  name='oldPin'
                  maxLength={4}
                  value={oldPin}
                  onChange={(e) => {
                    setFieldValue('oldPin', e.target.value)
                    oldPinCallback(e)
                  }}
                  pattern='/^[0-9\b]+$/'
                />
                <InputError text={errors.oldPin} touched={touched.oldPin} />
              </div>
              <div className='form-group'>
                <NeoInput
                  type='password'
                  text='New PIN'
                  maxLength={4}
                  onChange={(e) => {
                    setFieldValue('newPin', e.target.value)
                    newPinCallback(e)
                  }}
                  value={newPin}
                  disabled={loadingCards}
                  name='newPin'
                />
                <InputError text={errors.newPin} touched={touched.newPin} />
              </div>
              <div className='form-group'>
                <NeoInput
                  type='password'
                  text='Confirm New PIN'
                  value={newPinConfirm}
                  onChange={(e) => {
                    setFieldValue('confirmNewPin', e.target.value)
                    newPinConfirmCallback(e)
                  }}
                  maxLength={4}
                  name='confirmNewPin'
                  disabled={loadingCards}
                />
                <InputError text={errors.confirmNewPin} touched={touched.confirmNewPin} />
              </div>
              <div className='mt-3'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    mode={'newDesign'}
                    type='submit'
                    disabled={isSubmitting || loadingCards}
                    text='Submit'
                  />
                )}
              </div>
              <div className='back-cancel-style' onClick={() => history.goBack()}>
                {' '}
                Cancel{' '}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column'>
        <h3>Confirm Change Card Pin Request</h3>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <div >
          <h6 className='label'>Card Number</h6>
          <h6 className='value'>{formValues.cardNumber}</h6>
        </div>
        <div >
          <h6 className='label'>Expiry Month</h6>
          <h6 className='value'>{formValues.expiryMonth}</h6>
        </div>
        <div >
          <h6 className='label'>Expiry Year</h6>
          <h6 className='value'>{formValues.expiryYear}</h6>
        </div>
        <div className='mt-3'>
          {loading ? (
            <NeoLoader />
          ) : (
            <NeoButton type='button' text='Confirm' onClick={confirmClick} />
          )}
        </div>
      </div>
    )
  }

  return (
    <LayoutWithAccountCard
      title={parentMenuDetails.title}
      description={parentMenuDetails.desc}
      parentMenuList={parentMenus}
      icon={parentMenuDetails.icon}>
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}

export default ChangeCardPIN
